import BundlesContainer from './BundlesContainer';

export default BundlesContainer;
